<section>
    <div class="container">
        <div class="login-section card mx-auto p-5">
            <div class="header w-100 text-center mb-4">
                <img src="assets/Bergh-Bouwgroep-logo.png" height="64">
            </div>
            <div class="title">
                <h6 class="mb-4 bergh-text-primary text-center">{{lang.recoverPassword.title}}</h6>
            </div>
            <form [formGroup]="recoverPasswordForm" (ngSubmit)="recoverPasswordFormSubmit()" id="recoverPasswordForm">
                <div class="form-group">
                    <label for="passwordInput">{{lang.recoverPassword.passwordLabel}}</label>
                    <input type="password"
                           [ngClass]="{'form-control':true,'is-invalid':recoverPasswordForm.controls['password'].errors?.required && recoverPasswordForm.controls['password'].touched ||
                        recoverPasswordForm.controls['password'].errors?.minlength && recoverPasswordForm.controls['password'].touched}"
                           id="passwordInput"
                           formControlName="password"
                           placeholder="{{lang.recoverPassword.passwordPlaceholder}}">
                    <div class="invalid-feedback"*ngIf="recoverPasswordForm.controls['password'].errors?.required" id="emailError">{{lang.recoverPassword.passwordError}}</div>
                    <div class="invalid-feedback" *ngIf="recoverPasswordForm.controls['password'].errors?.minlength" id="emailError">
                        {{lang.recoverPassword.passwordHelperText}}
                      </div>
                </div>
                <div class="form-group">
                    <label for="repeatPasswordInput">{{lang.recoverPassword.repeatPasswordLabel}}</label>
                    <input type="password"
                           [ngClass]="{'form-control':true,'is-invalid':recoverPasswordForm.controls['repeatPassword'].invalid && recoverPasswordForm.controls['repeatPassword'].touched}"
                           id="repeatPasswordInput"
                           formControlName="repeatPassword"
                           placeholder="{{lang.recoverPassword.repeatPasswordPlaceholder}}"
                           (change)="passwordCheck()">
                    <div class="invalid-feedback" id="emailError">{{lang.recoverPassword.repeatPasswordError}}</div>
                </div>
                <div class="form-group mt-5">
                    <button class="btn bergh-bg-secondary text-white w-100" type="submit" id="submitBtn" [disabled]="recoverPasswordForm.invalid">{{lang.recoverPassword.recoverPasswordBtn}}</button>
                </div>
            </form>
        </div>
    </div>
</section>
